import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class PhBhpFeaturePackageSopobservationService {

  isCollapsed = true;

  constructor(private service: PHBHPApiService) { }

  getDepartmentList() {
    return this.service.getApi('Departments/GetDepartments', true);
  }
  getDepartmentById(id) {
    return this.service.getApi('Departments/GetDepartmentById/'+id, true);
  }
  getWardsbyInstitutionId(id) {
    return this.service.getApi('ManageInstitution/GetInstituionWards/'+ id, true);
  }
  getWardsDepartmentsbyInstitutionId(id) {
    return this.service.getApi('SOPEvaluation/GetWardsAndDepartments/'+ id, true);
  }
  
  getSOPObservationList(id,roleId,institutionID) {
    return this.service.getApi(`SOPObservation/GetSOPObservationList/${id}/${roleId}/${institutionID}`, true);
  }
  getSOPObservationProtocol(id,roleId,institutionID, countryId, lang) {
    return this.service.getApi(`SOPObservation/GetSOPObservationProtocol/${id}/${roleId}/${institutionID}/${countryId}/${lang}`, true);
  }
  createObservation(data) {
    return this.service.postApi(`observations/CreateObservation`, data,true);
  }
  getPredefinedComments() {
    return this.service.getApi('observations/GetPredefinedComments', true);
  }
  
  getConfigDetails(id){
    return this.service.getApi('ObserveObservation/GetGeneralConfigurationByInstitutionId/' + id, true);
  }
}
